"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CampaignDraft1ToJSON = exports.CampaignDraft1FromJSONTyped = exports.CampaignDraft1FromJSON = exports.instanceOfCampaignDraft1 = void 0;
var runtime_1 = require("../runtime");
var CampaignAdProduct1_1 = require("./CampaignAdProduct1");
/**
 * Check if a given object implements the CampaignDraft1 interface.
 */
function instanceOfCampaignDraft1(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfCampaignDraft1 = instanceOfCampaignDraft1;
function CampaignDraft1FromJSON(json) {
    return CampaignDraft1FromJSONTyped(json, false);
}
exports.CampaignDraft1FromJSON = CampaignDraft1FromJSON;
function CampaignDraft1FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'hierarchyDraftId': !(0, runtime_1.exists)(json, 'hierarchy_draft_id') ? undefined : json['hierarchy_draft_id'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'adProduct': !(0, runtime_1.exists)(json, 'ad_product') ? undefined : (0, CampaignAdProduct1_1.CampaignAdProduct1FromJSON)(json['ad_product']),
        'purchaseOrder': !(0, runtime_1.exists)(json, 'purchase_order') ? undefined : json['purchase_order'],
        'opportunityCode': !(0, runtime_1.exists)(json, 'opportunity_code') ? undefined : json['opportunity_code'],
        'createdAt': !(0, runtime_1.exists)(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'updatedAt': !(0, runtime_1.exists)(json, 'updated_at') ? undefined : (new Date(json['updated_at'])),
        'reservationIds': !(0, runtime_1.exists)(json, 'reservation_ids') ? undefined : json['reservation_ids'],
    };
}
exports.CampaignDraft1FromJSONTyped = CampaignDraft1FromJSONTyped;
function CampaignDraft1ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'hierarchy_draft_id': value.hierarchyDraftId,
        'name': value.name,
        'ad_product': (0, CampaignAdProduct1_1.CampaignAdProduct1ToJSON)(value.adProduct),
        'purchase_order': value.purchaseOrder,
        'opportunity_code': value.opportunityCode,
        'created_at': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updated_at': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'reservation_ids': value.reservationIds,
    };
}
exports.CampaignDraft1ToJSON = CampaignDraft1ToJSON;
